module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "w-100"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Sales Channel:")]), _vm._v(" " + _vm._s(_vm.paymentChannel()))]), _vm._v(" "), (_vm.paymentValue(_vm.payment)) ? _c('div', {
    staticClass: "w-100"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Value:")]), _vm._v(" " + _vm._s(_vm.paymentValue(_vm.payment)))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "w-100 d-flex align-items-center"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Payment Method:")]), _vm._v(" "), _c('v-select', {
    staticClass: "pay-in__dropdown mx-2 d-flex",
    attrs: {
      "disabled": _vm.readOnly || _vm.isReservationReadOnly && _vm.reservation.status != -5,
      "options": _vm.getPaymentTypeListAll,
      "label": "description",
      "placeholder": "- Select Payment Method -"
    },
    on: {
      "input": _vm.updatePaymentMethod
    },
    model: {
      value: (_vm.selectedPaymentMethod),
      callback: function($$v) {
        _vm.selectedPaymentMethod = $$v
      },
      expression: "selectedPaymentMethod"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "w-100"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Type:")]), _vm._v(" " + _vm._s(_vm.type(_vm.payment)))])]), _vm._v(" "), (_vm.treasurerName(_vm.payment)) ? _c('div', {
    staticClass: "d-flex"
  }, [(_vm.treasurerName(_vm.payment)) ? _c('div', {
    staticClass: "w-100"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Treasurer:")]), _vm._v(" " + _vm._s(_vm.treasurerName(_vm.payment)))]) : _vm._e(), _vm._v(" "), (_vm.createDate(_vm.payment)) ? _c('div', {
    staticClass: "w-100"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Created on:")]), _vm._v(" " + _vm._s(_vm.createDate(_vm.payment)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.paymentNotes(_vm.payment)) ? _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "w-100"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Notes:")]), _vm._v(" " + _vm._s(_vm.paymentNotes(_vm.payment)))])]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-f04050d2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f04050d2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationEditV2/TabPayments/expandedArea/payIn.vue
// module id = 1898
// module chunks = 0